import React from 'react';
import { ExcelTableCellProps } from '../../TableCell';
import DatePicker from './DatePicker';
import TimePicker from './TimePicker';
import DateTimePicker from './DateTimePicker';
import Browser from './Browser';


export default class BrowserElement extends React.Component<ExcelTableCellProps, any> {
    render() {
        const { cell, card } = this.props;
        const path = cell.getPath();
        const { fieldtype } = card.getFieldProps(path);
        if (fieldtype == '2') {
            return (
                <DatePicker {...this.props} />
            )
        } else if (fieldtype == '19') {
            return (
                <TimePicker {...this.props} />
            )
        }else if (fieldtype == '290'){
            return (
                <DateTimePicker {...this.props} />
            )
        }else {
            return (
                <Browser {...this.props} />
            )
        } 
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/browser-element/index.tsx